module.exports = __webpack_public_path__ + "static/media/ong.dd4423ad.svg";